import React, { useState } from 'react';
import { ListItem, ListItemText, Typography, IconButton, Box, Menu, MenuItem } from '@mui/material';
import UserAvatar from '../../../common/UserAvatar';
import ChatBubble from './ChatBubble';
import { useEditCommentMutation, useDeleteCommentMutation } from '../commentApiSlice';
import { formatTime } from '../../../utils/dateUtils';
import { Delete, Edit, MoreVert, ContentCopy } from '@mui/icons-material';
import toast from 'react-hot-toast';

const CommentItem = ({ comment, user, setEditingComment }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const [deleteComment] = useDeleteCommentMutation();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEditComment = () => {
    setEditingComment({ commentId: comment._id, commentText: comment.commentText });
    handleClose();
  };

  const handleDeleteComment = async () => {
    // await toast.promise(deleteComment(comment._id), {
    //   loading: 'Deleting comment...',
    //   success: 'Comment deleted successfully!',
    //   error: (err) => err.data?.message || 'Error deleting comment. Please try again.',
    // });
    await deleteComment(comment._id);
    setEditingComment(null);
    handleClose();
  };

  return (
    <>
      <ListItem
        alignItems="flex-start"
        sx={{ flexDirection: comment.authorEmpCode === user?.empCode ? 'row-reverse' : 'row' }}
      >
        {comment.authorEmpCode === user?.empCode ? (
          <></>
        ) : (
          <UserAvatar
            showStatus={false}
            src={comment.authorUserPhoto}
            sx={{ height: '30px', width: '30px', marginRight: 1, marginTop: '5px' }}
          />
        )}
        <ListItemText
          primary={
            <Box
              sx={{
                display: 'flex',
                justifyContent: comment.authorEmpCode === user?.empCode ? 'flex-end' : 'flex-start',
                alignItems: 'flex-end',
              }}
            >
              <Typography variant="caption" color="#555" sx={{ fontWeight: 'bold', fontSize: '12px' }}>
                {comment.authorEmpCode === user?.empCode ? (
                  formatTime(comment.datePosted)
                ) : (
                  <>
                    {comment.authorName}, {formatTime(comment.datePosted)}{' '}
                  </>
                )}
              </Typography>
              {comment.authorEmpCode === user?.empCode && (
                <IconButton
                  aria-label="more"
                  aria-controls="short-menu"
                  aria-haspopup="true"
                  onClick={handleClick}
                  size="small"
                  sx={{ ml: 0 }}
                >
                  <MoreVert sx={{ fontSize: '14px' }} />
                </IconButton>
              )}
            </Box>
          }
          secondary={<ChatBubble isOwnMessage={comment?.authorEmpCode === user?.empCode} comment={comment} />}
        />
        <Menu id="short-menu" anchorEl={anchorEl} keepMounted open={open} onClose={handleClose}>
          <MenuItem onClick={handleEditComment}>
            <Edit sx={{ marginRight: 1, fontSize: '14px' }} /> Edit
          </MenuItem>
          <MenuItem onClick={handleDeleteComment}>
            <Delete sx={{ marginRight: 1, fontSize: '14px' }} /> Delete
          </MenuItem>
        </Menu>
      </ListItem>
    </>
  );
};

export default CommentItem;
